/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
  Label,
} from "reactstrap";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import {
  getInsight,
  createInsight,
  editInsight,
  resetInsight,
  resetInsights,
  resetError,
} from "../../store/actions";

const Insight = ({ t }) => {
  let { idInsight } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    dataInsightGetSet,
    errorInsight,
    dataInsightEditCreate,
    successInsight,
    loadingInsightEditCreate,
  } = useSelector((state) => state.Insights);
  const [insightValues, setInsightValues] = useState({
    name: "",
    description: "",
    regex: "",
    clients: [],
    global: false,
  });

  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);

  const handleCreateEditInsight = () => {
    if (idInsight) {
      dispatch(
        editInsight(idInsight, {
          ...newFields,
        })
      );
    } else {
      dispatch(createInsight({ ...newFields }));
    }
  };

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successInsight &&
      dispatch(resetInsight()) &&
      dispatch(resetInsights()) &&
      history.push("/insights"),
  };

  const optionsClient = () => {
    let options = [];

    if (loadingInsightEditCreate) {
      options.push({
        value: "empty",
        label: `${t("Loading")} ...`,
        isDisabled: true,
      });
    } else {
      if (dataInsightGetSet?.data?.form?.clients?.length > 0) {
        options.push({
          value: "",
          label: t("Select"),
          isDisabled: true,
        });
        dataInsightGetSet.data.form.clients.map((client, key) =>
          options.push({
            key: key,
            value: client.id,
            label: client.name,
          })
        );
      } else {
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }

    return options;
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length !== 0) {
      setEnableSubmit(true);
    } else {
      setEnableSubmit(false);
    }
  };

  useEffect(() => {
    checkSubmit();
  }, [newFields]);

  useEffect(() => {
    dispatch(resetInsight());
    if (idInsight) {
      dispatch(getInsight(idInsight));
    } else {
      dispatch(getInsight());
    }
  }, [idInsight]);

  useEffect(() => {
    if (idInsight && dataInsightGetSet?.data) {
      setInsightValues((previous) => ({
        ...previous,
        name: dataInsightGetSet?.data?.insights[0]?.name ?? "",
        description: dataInsightGetSet?.data?.insights[0]?.description ?? "",
        regex: dataInsightGetSet?.data?.insights[0]?.regex ?? "",
        clients: dataInsightGetSet?.data?.insights[0]?.client_id ?? [],
        global: dataInsightGetSet?.data?.insights[0]?.global ?? false,
      }));
    }
  }, [dataInsightGetSet, idInsight]);

  useEffect(() => {
    if (dataInsightEditCreate?.message) {
      showToast("success", t(dataInsightEditCreate.message));
    }
  }, [successInsight]);

  useEffect(() => {
    if (errorInsight && Array.isArray(errorInsight)) {
      errorInsight.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorInsight) {
        showToast("error", t(errorInsight));
        dispatch(resetError());
      }
    }
  }, [errorInsight]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            mainPath="/insights"
            path={idInsight ? "/insight/" + idInsight : "/insight"}
            title={t("Insights")}
            breadcrumbItem={
              !idInsight ? t("Create Insight") : t("Edit Insight")
            }
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={handleCreateEditInsight}>
                    <Row>
                      <Col sm="6">
                        <FormGroup>
                          <AvField
                            value={insightValues.name}
                            label={t("Name") + " *"}
                            id="insightname"
                            name="insightname"
                            type="text"
                            className="form-control"
                            autocomplete="off"
                            placeholder={t("Enter your insight name")}
                            onChange={(e) => {
                              if (e.target.value === insightValues.name) {
                                delete newFields.name;
                                checkSubmit();
                              } else {
                                setNewFields({
                                  ...newFields,
                                  name: e.target.value,
                                });
                              }
                            }}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Invalid field"),
                              },
                              maxLength: {
                                value: 255,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            value={insightValues.description}
                            label={t("Description") + " *"}
                            id="insightdesc"
                            name="insightdesc"
                            type="text"
                            className="form-control"
                            autocomplete="off"
                            placeholder={t("Enter Insight description")}
                            onChange={(e) => {
                              if (
                                e.target.value === insightValues.description
                              ) {
                                delete newFields.description;
                                checkSubmit();
                              } else {
                                setNewFields({
                                  ...newFields,
                                  description: e.target.value,
                                });
                              }
                            }}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Invalid field"),
                              },
                              maxLength: {
                                value: 255,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="6">
                        <FormGroup>
                          <AvField
                            value={insightValues.regex}
                            label={t("RegEx") + " *"}
                            id="insightregex"
                            name="insightregex"
                            type="text"
                            className="form-control"
                            autocomplete="off"
                            placeholder={t("Enter your RegEx")}
                            onChange={(e) => {
                              if (e.target.value === insightValues.regex) {
                                delete newFields.regex;
                                checkSubmit();
                              } else {
                                setNewFields({
                                  ...newFields,
                                  regex: e.target.value,
                                });
                              }
                            }}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Invalid field"),
                              },
                              maxLength: {
                                value: 255,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />
                        </FormGroup>
                        <FormGroup className="select2-container">
                          <div className="d-flex justify-content-between w-100">
                            <Label className="control-label">
                              {t("Client")}
                            </Label>
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                checked={insightValues?.global}
                              />
                              <label
                                className="custom-control-label"
                                onClick={() => {
                                  setNewFields({
                                    ...newFields,
                                    global: !insightValues.global,
                                    client_id: [],
                                  });
                                  setInsightValues({
                                    ...insightValues,
                                    global: !insightValues.global,
                                    clients: [],
                                  });
                                }}
                              >
                                {t("All Companies")}
                              </label>
                            </div>
                          </div>
                          <Select
                            classNamePrefix="select2-selection"
                            placeholder={t("Select") + "..."}
                            title={t("Clients")}
                            options={optionsClient()}
                            onChange={(e) => {
                              setNewFields({
                                ...newFields,
                                global: false,
                                client_id: e ? e.map((item) => item.value) : [],
                              });
                              setInsightValues({
                                ...insightValues,
                                global: false,
                                clients: e ? e.map((item) => item.value) : [],
                              });
                            }}
                            value={optionsClient().filter((element) =>
                              insightValues?.clients?.includes(element.value)
                            )}
                            isDisabled={insightValues?.global}
                            isMulti
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button
                      type="submit"
                      color="primary"
                      className="mr-1 waves-effect waves-light"
                      style={{
                        minWidth: "100px",
                        cursor: enableSubmit ? "pointer" : "no-drop",
                      }}
                      disabled={!enableSubmit}
                    >
                      {loadingInsightEditCreate ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          style={{
                            height: "19px",
                            width: "19px",
                          }}
                        />
                      ) : (
                        t("Confirm")
                      )}
                    </Button>
                    <Link to="/insights">
                      {" "}
                      <Button
                        type="button"
                        color="secondary"
                        className="waves-effect"
                        onClick={() => dispatch(resetInsight())}
                      >
                        {t("Cancel")}
                      </Button>
                    </Link>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Insight);
